import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useConfig} from "./ConfigContext";
import GetAccessToken from "./Tokens";
import axios from "axios";

function TagInput({ tags, setTags }) {
    const [tag, setTag] = useState('');
    const [suggestedTags, setSuggestedTags] = useState([]);
    const [modelServiceUrl, setModelServiceUrl] = useState(null);
    const [allTags, setAllTags] = useState([]);
    const navigate = useNavigate();
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setModelServiceUrl(config["model_service_url"]);
        }
    }, [config]);

    useEffect(() => {
        const fetchAllTags = async () => {
            let access_token = await GetAccessToken(config["user_service_url"]);
            if (access_token === null) {
                navigate('/login');
                return;
            }
            try {
                const response = await axios.get(`${modelServiceUrl}/private/allTags`, {
                    headers: {
                        'Authorization': `Bearer ${access_token}`
                    }
                });
                setAllTags(response.data.tags);
            } catch (error) {
                console.error("Error fetching all tags:", error);
            }
        };

        if (modelServiceUrl) {
            fetchAllTags();
        }
    }, [modelServiceUrl]);

    useEffect(() => {
        if (tag.length > 0) {
            const filteredTags = allTags.filter(t => t.toLowerCase().includes(tag.toLowerCase()));
            setSuggestedTags(filteredTags);
        } else {
            setSuggestedTags([]);
        }
    }, [tag, allTags]);

    const handleAddTagButton = () => {
        if (tag && !tags.includes(tag)) {
            setTags([...tags, tag]);
            setTag('');
            setSuggestedTags([]);
        }
    };

    const handleAddTagClick = (suggestedTag) => {
        if (!tags.includes(suggestedTag)) {
            setTags([...tags, suggestedTag]);
            setTag('');
            setSuggestedTags([]);
        }
    };

    const handleRemoveTagClick = (tag) => {
        setTags(tags.filter(t => t !== tag));
    };

    return (
        <div>
            <div className="tag-input-container">
                <div className="tag-input">
                    <input
                        type="text"
                        placeholder="Enter tag"
                        value={tag}
                        onChange={(e) => setTag(e.target.value)}
                    />
                    <button onClick={handleAddTagButton}>Add Tag</button>
                </div>
            </div>
            {suggestedTags.length !== 0 &&
                <div className="suggested-tags-container">
                    <ul className="suggested-tags">
                        {suggestedTags
                            .filter(suggestedTag => !tags.includes(suggestedTag))
                            .map((suggestedTag, index) => (
                                <li key={index} onClick={() => { handleAddTagClick(suggestedTag); }}>
                                    {suggestedTag}
                                </li>
                            ))}
                    </ul>
                </div>
            }
            <div className="tags-list-container">
                <ul className="tags-list">
                    {tags.map((tag, index) => (
                        <li key={index} onClick={() => { handleRemoveTagClick(tag); }}>{tag}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default TagInput;